import { createContext } from 'react';
import { PopperArrowProps } from 'react-popper';
import { TypeColors } from '../Base/Base';

export const PlacementArrowPropsContext = createContext<PopperArrowProps & { backgroundColor?: TypeColors }>({
  backgroundColor: 'gray-1',
  ref: () => {},
  style: {},
});
